// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/cancel_my_account_deletion.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/cancel_my_account_deletion.proto.
 */
export const file_accounts_cancel_my_account_deletion: GenFile = /*@__PURE__*/
  fileDesc("CilhY2NvdW50cy9jYW5jZWxfbXlfYWNjb3VudF9kZWxldGlvbi5wcm90bxIPcHJvdG9zLmFjY291bnRzInIKHkNhbmNlbE15QWNjb3VudERlbGV0aW9uUmVxdWVzdBJGCgZwYXJhbXMYASABKAsyNi5wcm90b3MuYWNjb3VudHMuQ2FuY2VsTXlBY2NvdW50RGVsZXRpb25SZXF1ZXN0LlBhcmFtcxoICgZQYXJhbXMidAofQ2FuY2VsTXlBY2NvdW50RGVsZXRpb25SZXNwb25zZRJHCgZyZXN1bHQYASABKAsyNy5wcm90b3MuYWNjb3VudHMuQ2FuY2VsTXlBY2NvdW50RGVsZXRpb25SZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.accounts.CancelMyAccountDeletionRequest
 */
export type CancelMyAccountDeletionRequest = Message<"protos.accounts.CancelMyAccountDeletionRequest"> & {
  /**
   * @generated from field: protos.accounts.CancelMyAccountDeletionRequest.Params params = 1;
   */
  params?: CancelMyAccountDeletionRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.CancelMyAccountDeletionRequest.
 * Use `create(CancelMyAccountDeletionRequestSchema)` to create a new message.
 */
export const CancelMyAccountDeletionRequestSchema: GenMessage<CancelMyAccountDeletionRequest> = /*@__PURE__*/
  messageDesc(file_accounts_cancel_my_account_deletion, 0);

/**
 * @generated from message protos.accounts.CancelMyAccountDeletionRequest.Params
 */
export type CancelMyAccountDeletionRequest_Params = Message<"protos.accounts.CancelMyAccountDeletionRequest.Params"> & {
};

/**
 * Describes the message protos.accounts.CancelMyAccountDeletionRequest.Params.
 * Use `create(CancelMyAccountDeletionRequest_ParamsSchema)` to create a new message.
 */
export const CancelMyAccountDeletionRequest_ParamsSchema: GenMessage<CancelMyAccountDeletionRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_cancel_my_account_deletion, 0, 0);

/**
 * @generated from message protos.accounts.CancelMyAccountDeletionResponse
 */
export type CancelMyAccountDeletionResponse = Message<"protos.accounts.CancelMyAccountDeletionResponse"> & {
  /**
   * @generated from field: protos.accounts.CancelMyAccountDeletionResponse.Result result = 1;
   */
  result?: CancelMyAccountDeletionResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.CancelMyAccountDeletionResponse.
 * Use `create(CancelMyAccountDeletionResponseSchema)` to create a new message.
 */
export const CancelMyAccountDeletionResponseSchema: GenMessage<CancelMyAccountDeletionResponse> = /*@__PURE__*/
  messageDesc(file_accounts_cancel_my_account_deletion, 1);

/**
 * @generated from message protos.accounts.CancelMyAccountDeletionResponse.Result
 */
export type CancelMyAccountDeletionResponse_Result = Message<"protos.accounts.CancelMyAccountDeletionResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.CancelMyAccountDeletionResponse.Result.
 * Use `create(CancelMyAccountDeletionResponse_ResultSchema)` to create a new message.
 */
export const CancelMyAccountDeletionResponse_ResultSchema: GenMessage<CancelMyAccountDeletionResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_cancel_my_account_deletion, 1, 0);

